import { useState } from "react";
import { IAhRecord, IDoctor } from "../../interfaces/api";
import AddressTile from "./AddressTile.component";

const MedicalGroupTile = ({
  data,
  AddDocDrug,
  doctorInfo,
  goToSearch,
}: {
  data: IAhRecord;
  AddDocDrug: (data: IDoctor) => void;
  doctorInfo: IDoctor;
  goToSearch: () => void;
}) => {
  const [, setFilteredAhRecords] = useState(doctorInfo.ahRecords);

  const handleGroupSelect = (desc: string) => {
    const filteredRecords = doctorInfo.ahRecords.filter(
      (record) => record.ipa.desc === desc
    );
    setFilteredAhRecords(filteredRecords);

    const updatedDoctorInfo = {
      ...doctorInfo,
      ahRecords: filteredRecords,
    };

    AddDocDrug(updatedDoctorInfo);
  };

  const onSelectGroup = (name: string) => {
    handleGroupSelect(name);
    !sessionStorage.getItem("doctorProviderID") &&
      sessionStorage.setItem(
        "doctorProviderID",
        doctorInfo.ahRecords[0].providerID
      );
    goToSearch();
  };

  return (
    <>
      <div
        className="hide-for-small-only"
        style={{
          border: "1px solid #1B54C2",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          margin: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "16px 16px 8px 16px",
          }}
        >
          <div>
            <h3
              className="secondary-color"
              style={{
                fontSize: "22px",
                paddingBottom: "8px",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
            >
              {data.ipa.desc.toLowerCase()}
            </h3>
            <div style={{ paddingBottom: "16px" }}>
              <span style={{ fontWeight: 600 }}>Provider Id:</span>{" "}
              {data.providerID}
            </div>
            <div style={{ fontWeight: 600 }}>Location(s)</div>
          </div>
          <button
            type="button"
            className="button"
            style={{
              fontWeight: 700,
              maxHeight: 55,
              fontSize: 20,
            }}
            onClick={() => onSelectGroup(data.ipa.desc)}
          >
            Select Group
          </button>
        </div>
        {data.addresses.map((address, index) => (
          <AddressTile data={address} key={index} />
        ))}
      </div>
      <div
        className="show-for-small-only"
        style={{
          border: "1px solid #1B54C2",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          margin: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "16px 16px 8px 16px",
          }}
        >
          <div>
            <h3
              className="secondary-color"
              style={{
                fontSize: "22px",
                paddingBottom: "8px",
                fontWeight: 600,
              }}
            >
              {data.ipa.desc}
            </h3>
            <div style={{ paddingBottom: "16px" }}>
              <span style={{ fontWeight: 600 }}>Provider Id:</span>{" "}
              {data.providerID}
            </div>
            <div style={{ fontWeight: 600 }}>Location(s)</div>
          </div>
          <button
            type="button"
            className="button"
            style={{
              fontWeight: 700,
              maxHeight: 70,
            }}
            onClick={() => onSelectGroup(data.ipa.desc)}
          >
            Select Group
          </button>
        </div>
        {data.addresses.map((address, index) => (
          <AddressTile data={address} key={index} />
        ))}
      </div>
    </>
  );
};

export default MedicalGroupTile;
